import { useMemo } from "react";
import LoyaltyListRewardsRedesign from "components/organisms/LoyaltyListRewardsRedesign";
import { useSelector } from "react-redux";
import { useAssignCashback } from "queries/useAssignCashback";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { Loyalty } from "types/Loyalty";
import { useGetLoyaltyRewardsUser } from "queries/useGetLoyaltyRewardsUser";
import { useGetRewardsInfo } from "queries/useGetRewardsInfo";
import { useLoyaltyRewardAssign } from "queries/useLoyaltyRewardAssign";
import { useGetCashbackInfo } from "queries/useGetCashbackInfo";
import { formatLoyaltyRewardsUser } from "utils/loyalty-rewards";
import * as userSelectors from "../../redux/user/selectors";

export const LoyaltyListRewardsRedesignContainer = () => {
  const { data } = useGetLoyaltyUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loyalty = data?.data?.data || ({} as Loyalty);
  const { userRewards } = useGetLoyaltyRewardsUser({ loyaltyId: loyalty?.id });
  const currency = useSelector(userSelectors.currentCurrency);
  const idsRewards = userRewards.map((reward) => reward.rewardId) || [];
  const { rewardsInfo } = useGetRewardsInfo(idsRewards);
  const { handleAssignReward } = useLoyaltyRewardAssign(loyalty.id || "");
  const { handleAssignCashback } = useAssignCashback();
  const { cashbackDaily, cashbackWeekly, cashbackMonthly } =
    useGetCashbackInfo();

  const { nominals, cashback, freeSpins } = useMemo(
    () =>
      formatLoyaltyRewardsUser({
        loyalty,
        currency,
        userRewards,
        infoRewards: rewardsInfo,
        dailyCashback: cashbackDaily,
        monthlyCashback: cashbackMonthly,
        weeklyCashback: cashbackWeekly,
        assignReward: handleAssignReward,
        assignCashback: handleAssignCashback,
      }),
    [
      cashbackDaily,
      cashbackMonthly,
      cashbackWeekly,
      currency,
      handleAssignCashback,
      handleAssignReward,
      loyalty,
      rewardsInfo,
      userRewards,
    ],
  );

  return (
    <LoyaltyListRewardsRedesign
      nominals={nominals}
      cashback={cashback}
      freeSpins={freeSpins}
    />
  );
};
